exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".users[data-v-88e41df6]{margin-bottom:27px;list-style:none}.users__items[data-v-88e41df6]{margin-bottom:9px;padding:6px 0 15px;border-bottom:1px solid #dadada}.users__items[data-v-88e41df6]:last-child{margin-bottom:0}.users__wrap .cheked_block[data-v-88e41df6]{display:-ms-flexbox;display:flex}.users__error[data-v-88e41df6]{margin-top:9px;line-height:1.2;font-size:14px;color:red}.users__fio[data-v-88e41df6]{margin-left:9px;font-weight:700;color:#1d1d1d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-88e41df6","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/catalog/card/components/request/components/requestform/components/userslist/RequestUsersList.vue
// module id = 9e7d73e275cc97344606
// module chunks = 6